const MAFAA010 = () => {
    return <h1 className="blank-page-title">작업중입니다</h1>;
};
export default MAFAA010;
